import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  // null = checking, user object = authed, false = not authed
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const u = await api.me();
      setUser(u);
      return u;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    // Returning from Google OAuth — AuthCallback will establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { user: u } = await api.login(email, password);
    setUser(u);
    return u;
  };
  const register = async (body) => {
    const { user: u } = await api.register(body);
    setUser(u);
    return u;
  };
  const logout = async () => {
    try { await api.logout(); } catch { /* ignore */ }
    setUser(false);
  };

  // keep the credit balance fresh without a full reload
  const setCredits = (credits) => setUser((p) => (p ? { ...p, credits } : p));

  // send the user to Stripe to buy a 25-credit top-up ($25)
  const buyCredits = async () => {
    const { checkout_url } = await api.checkout("topup_25");
    window.location.href = checkout_url;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refresh, login, register, logout, setCredits, buyCredits }}>
      {children}
    </AuthContext.Provider>
  );
}
